import React, { createContext, useContext, useMemo } from 'react';

import type { ServerConfig } from '../types/login';

// ---------------------------------------------------------------------------
// Parse server-rendered globals from the HTML page
// ---------------------------------------------------------------------------

const parseServerConfig = (): ServerConfig => {
    const win = window as unknown as Record<string, unknown>;
    return {
        returnUrl: (win.RETURN_URL as string) ?? '',
    };
};

// ---------------------------------------------------------------------------
// Context
// ---------------------------------------------------------------------------

const LoginFlowContext = createContext<ServerConfig | null>(null);

export const useLoginFlow = (): ServerConfig => {
    const ctx = useContext(LoginFlowContext);
    if (!ctx) {
        throw new Error('useLoginFlow must be used within <LoginFlowProvider>');
    }
    return ctx;
};

export const LoginFlowProvider = ({ children }: { children: React.ReactNode }) => {
    const config = useMemo(parseServerConfig, []);

    return (
        <LoginFlowContext.Provider value={config}>
            {children}
        </LoginFlowContext.Provider>
    );
};
